import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vShow as _vShow, Transition as _Transition, toDisplayString as _toDisplayString, withKeys as _withKeys, vModelText as _vModelText, Fragment as _Fragment, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"
import _imports_0 from './assets/CarinaFinal.mp4'


const _hoisted_1 = { id: "main-content" }
const _hoisted_2 = { id: "first-splash-row" }
const _hoisted_3 = { id: "splash-screen-acknowledgements" }
const _hoisted_4 = { id: "splash-screen-logos" }
const _hoisted_5 = {
  class: "modal",
  id: "modal-loading"
}
const _hoisted_6 = { id: "top-content" }
const _hoisted_7 = { id: "center-buttons-wrapper" }
const _hoisted_8 = { id: "bottom-content" }
const _hoisted_9 = {
  key: 0,
  id: "tools"
}
const _hoisted_10 = { class: "tool-container" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  id: "credits",
  class: "ui-text"
}
const _hoisted_13 = { id: "icons-container" }
const _hoisted_14 = { class: "video-wrapper" }
const _hoisted_15 = { id: "user-experience-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_credit_logos = _resolveComponent("credit-logos")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_funding_acknowledgment = _resolveComponent("funding-acknowledgment")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_user_experience = _resolveComponent("user-experience")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_cds_privacy_policy = _resolveComponent("cds-privacy-policy")!
  const _component_v_app = _resolveComponent("v-app")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(_ctx.cssVars)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_WorldWideTelescope, { "wwt-namespace": _ctx.wwtNamespace }, null, 8, ["wwt-namespace"]),
        _createVNode(_component_v_overlay, {
          "model-value": _ctx.showSplashScreen,
          absolute: "",
          opacity: "0.6",
          style: _normalizeStyle(_ctx.cssVars),
          id: "splash-overlay"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              id: "splash-screen",
              style: _normalizeStyle(_ctx.cssVars)
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_font_awesome_icon, {
                  id: "close-splash-button",
                  onClick: _ctx.closeSplashScreen,
                  icon: "xmark"
                }, null, 8, ["onClick"]),
                _cache[24] || (_cache[24] = _createElementVNode("div", { id: "splash-screen-text" }, [
                  _createElementVNode("p", null, "Want to see in the"),
                  _createElementVNode("p", { class: "highlight" }, "INFRARED"),
                  _createElementVNode("p", null, "like JWST can?")
                ], -1))
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  class: "splash-get-started",
                  onClick: _ctx.closeSplashScreen,
                  color: _ctx.accentColor,
                  density: _ctx.xSmallSize ? 'compact' : 'default',
                  size: "x-large",
                  variant: "elevated",
                  rounded: "lg"
                }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createTextVNode(" Get Started ", -1)
                  ])),
                  _: 1,
                  __: [25]
                }, 8, ["onClick", "color", "density"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _cache[26] || (_cache[26] = _createTextVNode(" Brought to you by ", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("a", {
                  href: "https://www.cosmicds.cfa.harvard.edu/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "Cosmic Data Stories", -1)),
                _cache[28] || (_cache[28] = _createTextVNode(" and ", -1)),
                _cache[29] || (_cache[29] = _createElementVNode("a", {
                  href: "https://www.worldwidetelescope.org/home/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "WorldWide Telescope", -1)),
                _cache[30] || (_cache[30] = _createTextVNode(". ", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
                ])
              ])
            ], 4)), [
              [_directive_click_outside, _ctx.closeSplashScreen]
            ])
          ]),
          _: 1
        }, 8, ["model-value", "style"]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_5, _cache[31] || (_cache[31] = [
              _createElementVNode("div", { class: "container" }, [
                _createElementVNode("div", { class: "spinner" }),
                _createElementVNode("p", null, "Loading …")
              ], -1)
            ]), 512), [
              [_vShow, _ctx.isLoading]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_icon_button, {
            modelValue: _ctx.showVideoSheet,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
            id: "video-icon",
            color: _ctx.accentColor,
            "fa-icon": "video",
            "tooltip-location": _ctx.smallSize ? 'bottom' : 'end',
            "tooltip-text": "Watch video",
            "tooltip-offset": "10px",
            "show-tooltip": !_ctx.mobile
          }, null, 8, ["modelValue", "color", "tooltip-location", "show-tooltip"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              id: "show-layers-button",
              class: "ui-text",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLayers = !_ctx.showLayers))
            }, _toDisplayString(_ctx.showLayers ? "Hide Images" : "Show Images"), 1),
            _createVNode(_component_icon_button, {
              id: "reset-icon",
              "fa-icon": "redo",
              color: _ctx.accentColor,
              onActivate: _cache[2] || (_cache[2] = () => _ctx.resetView(false)),
              "tooltip-text": "Return to Carina",
              "tooltip-location": "bottom",
              "tooltip-offset": "3px",
              "show-tooltip": !_ctx.mobile
            }, null, 8, ["color", "show-tooltip"])
          ]),
          _createVNode(_component_icon_button, {
            id: "text-icon",
            "fa-icon": "book-open",
            color: _ctx.accentColor,
            modelValue: _ctx.showTextSheet,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showTextSheet) = $event)),
            "tooltip-text": "Learn more",
            "tooltip-location": _ctx.smallSize ? 'bottom' : 'start',
            "tooltip-offset": _ctx.smallSize ? '0' : '10px',
            "show-tooltip": !_ctx.mobile
          }, null, 8, ["color", "modelValue", "tooltip-location", "tooltip-offset", "show-tooltip"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.showLayers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.currentTool == 'crossfade')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", {
                          class: "ui-text slider-label",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.crossfadeOpacity = 0)),
                          onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.crossfadeOpacity = 0), ["enter"])),
                          tabindex: "0"
                        }, _cache[32] || (_cache[32] = [
                          _createTextVNode("Hubble", -1),
                          _createElementVNode("br", null, null, -1),
                          _createElementVNode("span", { class: "light-type" }, "(Visible)", -1)
                        ]), 32),
                        _withDirectives(_createElementVNode("input", {
                          class: "opacity-range",
                          type: "range",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.crossfadeOpacity) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.crossfadeOpacity]
                        ]),
                        _createElementVNode("span", {
                          class: "ui-text slider-label",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.crossfadeOpacity = 100)),
                          onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.crossfadeOpacity = 100), ["enter"])),
                          tabindex: "0"
                        }, _cache[33] || (_cache[33] = [
                          _createTextVNode("JWST", -1),
                          _createElementVNode("br", null, null, -1),
                          _createElementVNode("span", { class: "light-type" }, "(Infrared)", -1)
                        ]), 32)
                      ], 64))
                    : (_ctx.currentTool == 'choose-background')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _cache[34] || (_cache[34] = _createElementVNode("span", null, "Background imagery:", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.curBackgroundImagesetName) = $event))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backgroundImagesets, (bg) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: bg.imagesetName,
                                key: bg.imagesetName
                              }, _toDisplayString(bg.displayName), 9, _hoisted_11))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.curBackgroundImagesetName]
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
            ])
          ])
        ]),
        _createVNode(_component_v_dialog, {
          class: "error-dialog",
          style: _normalizeStyle(_ctx.cssVars),
          modelValue: _ctx.showWebGL2Warning,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showWebGL2Warning) = $event)),
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => _cache[35] || (_cache[35] = [
                _createElementVNode("div", { class: "error-message" }, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, "This app requires WebGL 2")
                  ]),
                  _createElementVNode("p", { class: "mt-2" }, " Check your browser's settings and enable WebGL 2 (\"graphics acceleration\" on some browsers). "),
                  _createElementVNode("p", { class: "mt-2" }, [
                    _createTextVNode(" You can check whether your browser supports WebGL 2 and get assistance "),
                    _createElementVNode("a", {
                      href: "https://get.webgl.org/webgl2/",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, "here"),
                    _createTextVNode(". ")
                  ])
                ], -1)
              ])),
              _: 1,
              __: [35]
            })
          ]),
          _: 1
        }, 8, ["style", "modelValue"]),
        _createVNode(_component_v_dialog, {
          id: "video-container",
          modelValue: _ctx.showVideoSheet,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
          transition: "slide-y-transition",
          fullscreen: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_font_awesome_icon, {
                class: "close-icon",
                icon: "times",
                size: "lg",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showVideoSheet = false)),
                onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.showVideoSheet = false), ["enter"])),
                tabindex: "0"
              }),
              _cache[36] || (_cache[36] = _createElementVNode("video", {
                controls: "",
                id: "info-video"
              }, [
                _createElementVNode("source", {
                  src: _imports_0,
                  type: "video/mp4"
                })
              ], -1))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          class: "bottom-sheet",
          id: "text-bottom-sheet",
          "hide-overlay": "",
          persistent: "",
          absolute: "",
          width: "100%",
          scrim: false,
          location: "bottom",
          modelValue: _ctx.showTextSheet,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showTextSheet) = $event)),
          transition: "dialog-bottom-transition",
          "retain-focus": !_ctx.showRating
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { height: "100%" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.tab) = $event)),
                  height: "32px",
                  "slider-color": "white",
                  id: "tabs",
                  dense: "",
                  grow: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { tabindex: "0" }, {
                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                        _createElementVNode("h3", null, "Information", -1)
                      ])),
                      _: 1,
                      __: [37]
                    }),
                    _createVNode(_component_v_tab, { tabindex: "0" }, {
                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                        _createElementVNode("h3", null, "Using WWT", -1)
                      ])),
                      _: 1,
                      __: [38]
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_font_awesome_icon, {
                  id: "close-text-icon",
                  class: "control-icon",
                  icon: "times",
                  size: "lg",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showTextSheet = false)),
                  onKeyup: _cache[16] || (_cache[16] = _withKeys(($event: any) => (_ctx.showTextSheet = false), ["enter"])),
                  tabindex: "0"
                }),
                _createVNode(_component_v_window, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.tab) = $event)),
                  id: "tab-items",
                  class: "pb-2 no-bottom-border-radius"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                              default: _withCtx(() => [
                                _cache[39] || (_cache[39] = _createElementVNode("h4", null, "Explore!", -1)),
                                _cache[40] || (_cache[40] = _createTextVNode(" As scientists, we learn by observing and noticing. Explore these images of the ", -1)),
                                _cache[41] || (_cache[41] = _createElementVNode("a", {
                                  href: "https://webbtelescope.org/contents/media/images/2022/031/01G77PKB8NKR7S8Z6HBXMYATGJ",
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }, "Carina Nebula", -1)),
                                _cache[42] || (_cache[42] = _createTextVNode(" and see what you can find.", -1)),
                                _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
                                _cache[44] || (_cache[44] = _createTextVNode(" • Look for stars that are “invisible” to our eyes because they are blocked by dust but shine in JWST’s infrared image.", -1)),
                                _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                                _cache[46] || (_cache[46] = _createTextVNode(" • Look near the edge of the dusty, dense clouds in the JWST image. See if you can find bright yellow arcs that indicate gas and dust being blown away by young forming stars.", -1)),
                                _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
                                _cache[48] || (_cache[48] = _createTextVNode(" • Scan the dark blue region of the JWST image and see if you can find reddish smudgy objects that might be galaxies. Switch over to the Hubble image. Do you see those galaxies in the Hubble image?", -1)),
                                _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
                                _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
                                _cache[51] || (_cache[51] = _createElementVNode("h4", null, "Images as “data”", -1)),
                                _cache[52] || (_cache[52] = _createTextVNode(" When you think about scientific data, pictures might not immediately spring to mind, but in astronomy, images are some of the most important pieces of data available. ", -1)),
                                _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1)),
                                _cache[54] || (_cache[54] = _createElementVNode("br", null, null, -1)),
                                _cache[55] || (_cache[55] = _createTextVNode(" Images show us the structure of objects in space, which here provides clues on how stars form and evolve. In the Hubble and JWST images of the Carina Nebula, you can see regions of very high density dust and gas (the brown parts of the images) where new stars are being born. If you zoom out, you will see that the images are at the edge of what appears to be a larger bubble, which is the cavern of lower density gas carved out by winds from massive stars. ", -1)),
                                _cache[56] || (_cache[56] = _createElementVNode("br", null, null, -1)),
                                _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1)),
                                _cache[58] || (_cache[58] = _createElementVNode("h4", null, "Visible vs Infrared Light", -1)),
                                _cache[59] || (_cache[59] = _createTextVNode(" Our eyes can detect visible light, but visible light is only a small part of a broader ", -1)),
                                _cache[60] || (_cache[60] = _createElementVNode("a", {
                                  href: "https://hubblesite.org/contents/articles/the-electromagnetic-spectrum",
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }, "spectrum", -1)),
                                _cache[61] || (_cache[61] = _createTextVNode(" of light that has different energies, ranging from gamma rays and x-rays to infrared light and radio waves. Images from each part of the spectrum can tell a different part of the story about objects in space. ", -1)),
                                _cache[62] || (_cache[62] = _createElementVNode("br", null, null, -1)),
                                _cache[63] || (_cache[63] = _createElementVNode("br", null, null, -1)),
                                _cache[64] || (_cache[64] = _createTextVNode(" The Hubble Space Telescope takes pictures in visible light, like our eyes. The James Webb Space Telescope takes pictures in infrared light. Some “night vision” cameras image objects in the dark using infrared light. Animals and people “glow” in infrared in the dark because we usually have higher temperatures than our surroundings. ", -1)),
                                _cache[65] || (_cache[65] = _createElementVNode("br", null, null, -1)),
                                _cache[66] || (_cache[66] = _createElementVNode("br", null, null, -1)),
                                _cache[67] || (_cache[67] = _createElementVNode("br", null, null, -1)),
                                _cache[68] || (_cache[68] = _createElementVNode("h3", null, "Credits:", -1)),
                                _cache[69] || (_cache[69] = _createElementVNode("h4", null, [
                                  _createElementVNode("a", {
                                    href: "https://www.cosmicds.cfa.harvard.edu/",
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, "CosmicDS"),
                                  _createTextVNode(" Team:")
                                ], -1)),
                                _cache[70] || (_cache[70] = _createTextVNode(" Jon Carifio", -1)),
                                _cache[71] || (_cache[71] = _createElementVNode("br", null, null, -1)),
                                _cache[72] || (_cache[72] = _createTextVNode(" John Lewis", -1)),
                                _cache[73] || (_cache[73] = _createElementVNode("br", null, null, -1)),
                                _cache[74] || (_cache[74] = _createTextVNode(" Pat Udomprasert", -1)),
                                _cache[75] || (_cache[75] = _createElementVNode("br", null, null, -1)),
                                _cache[76] || (_cache[76] = _createTextVNode(" Alyssa Goodman", -1)),
                                _cache[77] || (_cache[77] = _createElementVNode("br", null, null, -1)),
                                _cache[78] || (_cache[78] = _createTextVNode(" Mary Dussault", -1)),
                                _cache[79] || (_cache[79] = _createElementVNode("br", null, null, -1)),
                                _cache[80] || (_cache[80] = _createTextVNode(" Evaluator: Sue Sunbury", -1)),
                                _cache[81] || (_cache[81] = _createElementVNode("br", null, null, -1)),
                                _cache[82] || (_cache[82] = _createElementVNode("br", null, null, -1)),
                                _cache[83] || (_cache[83] = _createElementVNode("h4", null, "WorldWide Telescope Team:", -1)),
                                _cache[84] || (_cache[84] = _createTextVNode(" Peter Williams", -1)),
                                _cache[85] || (_cache[85] = _createElementVNode("br", null, null, -1)),
                                _cache[86] || (_cache[86] = _createTextVNode(" A. David Weigel", -1)),
                                _cache[87] || (_cache[87] = _createElementVNode("br", null, null, -1)),
                                _cache[88] || (_cache[88] = _createTextVNode(" Jon Carifio", -1)),
                                _cache[89] || (_cache[89] = _createElementVNode("br", null, null, -1)),
                                _cache[90] || (_cache[90] = _createElementVNode("br", null, null, -1)),
                                _createVNode(_component_funding_acknowledgment),
                                _createVNode(_component_v_spacer, { class: "end-spacer" })
                              ]),
                              _: 1,
                              __: [39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90]
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "no-bottom-border-radius scrollable",
                          style: {"height":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_container, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { align: "center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              label: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => _cache[91] || (_cache[91] = [
                                                _createTextVNode(" Pan ", -1)
                                              ])),
                                              _: 1,
                                              __: [91]
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "pt-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "press + drag" : "click + drag"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "or") + " ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? ":" : "W-A-S-D"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "keys"), 1),
                                            _cache[92] || (_cache[92] = _createElementVNode("br", null, null, -1))
                                          ]),
                                          _: 1,
                                          __: [92]
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { align: "center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              label: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => _cache[93] || (_cache[93] = [
                                                _createTextVNode(" Zoom ", -1)
                                              ])),
                                              _: 1,
                                              __: [93]
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "pt-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "pinch in and out" : "scroll in and out"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "or") + " ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? ":" : "I-O"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "keys"), 1),
                                            _cache[94] || (_cache[94] = _createElementVNode("br", null, null, -1))
                                          ]),
                                          _: 1,
                                          __: [94]
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => _cache[95] || (_cache[95] = [
                                            _createElementVNode("div", { style: {"min-height":"120px"} }, [
                                              _createElementVNode("p", null, [
                                                _createTextVNode(" The frame above provides an "),
                                                _createElementVNode("b", null, "interactive view "),
                                                _createTextVNode("of the night sky, powered by WorldWide Telescope (WWT). Here you can see a portion of the Carina Nebula imaged by the "),
                                                _createElementVNode("a", {
                                                  href: "https://hubblesite.org/",
                                                  target: "_blank",
                                                  rel: "noopener noreferrer"
                                                }, "Hubble Space Telescope"),
                                                _createTextVNode(" and the "),
                                                _createElementVNode("a", {
                                                  href: "https://webbtelescope.org/",
                                                  target: "_blank",
                                                  rel: "noopener noreferrer"
                                                }, "James Webb Space Telescope"),
                                                _createTextVNode(". These colorful images are overlaid against a background of the whole sky. ")
                                              ]),
                                              _createElementVNode("p", null, "You can zoom out to see where these images fit within a larger cloud of gas and dust."),
                                              _createElementVNode("p", null, "You can zoom in to see stunning detail within both images."),
                                              _createElementVNode("p", null, "You can switch between the Hubble and Webb images and compare their views by using the slider, or you can hide both images and explore the whole sky. Click the reset button if you want to return to the location of the Carina Nebula.")
                                            ], -1)
                                          ])),
                                          _: 1,
                                          __: [95]
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _cache[96] || (_cache[96] = _createElementVNode("h3", null, "Credits:", -1)),
                                            _cache[97] || (_cache[97] = _createElementVNode("h4", null, [
                                              _createElementVNode("a", {
                                                href: "https://www.cosmicds.cfa.harvard.edu/",
                                                target: "_blank",
                                                rel: "noopener noreferrer"
                                              }, "CosmicDS"),
                                              _createTextVNode(" Team:")
                                            ], -1)),
                                            _cache[98] || (_cache[98] = _createTextVNode(" Jon Carifio", -1)),
                                            _cache[99] || (_cache[99] = _createElementVNode("br", null, null, -1)),
                                            _cache[100] || (_cache[100] = _createTextVNode(" John Lewis", -1)),
                                            _cache[101] || (_cache[101] = _createElementVNode("br", null, null, -1)),
                                            _cache[102] || (_cache[102] = _createTextVNode(" Pat Udomprasert", -1)),
                                            _cache[103] || (_cache[103] = _createElementVNode("br", null, null, -1)),
                                            _cache[104] || (_cache[104] = _createTextVNode(" Alyssa Goodman", -1)),
                                            _cache[105] || (_cache[105] = _createElementVNode("br", null, null, -1)),
                                            _cache[106] || (_cache[106] = _createTextVNode(" Mary Dussault", -1)),
                                            _cache[107] || (_cache[107] = _createElementVNode("br", null, null, -1)),
                                            _cache[108] || (_cache[108] = _createTextVNode(" Evaluator: Sue Sunbury", -1)),
                                            _cache[109] || (_cache[109] = _createElementVNode("br", null, null, -1)),
                                            _cache[110] || (_cache[110] = _createElementVNode("br", null, null, -1)),
                                            _cache[111] || (_cache[111] = _createElementVNode("h4", null, "WorldWide Telescope Team:", -1)),
                                            _cache[112] || (_cache[112] = _createTextVNode(" Peter Williams", -1)),
                                            _cache[113] || (_cache[113] = _createElementVNode("br", null, null, -1)),
                                            _cache[114] || (_cache[114] = _createTextVNode(" A. David Weigel", -1)),
                                            _cache[115] || (_cache[115] = _createElementVNode("br", null, null, -1)),
                                            _cache[116] || (_cache[116] = _createTextVNode(" Jon Carifio", -1)),
                                            _cache[117] || (_cache[117] = _createElementVNode("br", null, null, -1)),
                                            _createVNode(_component_v_spacer, { class: "end-spacer" })
                                          ]),
                                          _: 1,
                                          __: [96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117]
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "retain-focus"])
      ]),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              (_ctx.showRating)
                ? (_openBlock(), _createBlock(_component_user_experience, {
                    key: 0,
                    question: _ctx.question,
                    "icon-size": "3x",
                    onDismiss: _cache[20] || (_cache[20] = (_rating, _comments) => {
            _ctx.showRating = false;
          }),
                    onRating: _cache[21] || (_cache[21] = (rating) => {
            _ctx.currentRating = rating;
            _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
          }),
                    onFinish: _cache[22] || (_cache[22] = (rating, comments) => {
            _ctx.currentRating = rating;
            _ctx.currentComments = comments;
            _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
            _ctx.showRating = false;
          })
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_v_btn, {
                          class: "rating-opt-put",
                          color: "#BDBDBD",
                          size: "small",
                          variant: "text",
                          onClick: _ctx.onOptOutClicked
                        }, {
                          default: _withCtx(() => _cache[118] || (_cache[118] = [
                            _createTextVNode(" Don't show again ", -1)
                          ])),
                          _: 1,
                          __: [118]
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          class: "privacy-button",
                          color: "#BDBDBD",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showPrivacyDialog = true)),
                          size: "small",
                          target: "_blank",
                          rel: "noopener noreferrer",
                          variant: "text"
                        }, {
                          default: _withCtx(() => _cache[119] || (_cache[119] = [
                            _createTextVNode(" What is this? ", -1)
                          ])),
                          _: 1,
                          __: [119]
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["question"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_cds_privacy_policy, {
            modelValue: _ctx.showPrivacyDialog,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.showPrivacyDialog) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}